import { Injectable } from '@angular/core';

@Injectable()
export class TaxCodeDataService {
  constructor() {}

  private _taxCode = [
    { country: 'Other', value: 'XX' },
    { country: 'Austria', value: 'AT' },
    { country: 'Belgium', value: 'BE' },
    { country: 'Bulgaria', value: 'BG' },
    { country: 'Croatia', value: 'HR' },
    { country: 'Cyprus', value: 'CY' },
    { country: 'Czech Republic', value: 'CZ' },
    { country: 'Denmark', value: 'DK' },
    { country: 'Estonia', value: 'EE' },
    { country: 'Finland', value: 'FI' },
    { country: 'France', value: 'FR' },
    { country: 'Germany', value: 'DE' },
    { country: 'Greece', value: 'GR' },
    { country: 'Greece', value: 'EL' },
    { country: 'Hungary', value: 'HU' },
    { country: 'Ireland', value: 'IE' },
    { country: 'Italy', value: 'IT' },
    { country: 'Latvia', value: 'LV' },
    { country: 'Lithuania', value: 'LT' },
    { country: 'Luxembourg', value: 'LU' },
    { country: 'Malta', value: 'MT' },
    { country: 'Netherlands', value: 'NL' },
    { country: 'Norway', value: 'NO' },
    { country: 'Poland', value: 'PL' },
    { country: 'Portugal', value: 'PT' },
    { country: 'Romania', value: 'RO' },
    { country: 'Slovakia', value: 'SK' },
    { country: 'Slovenia', value: 'SI' },
    { country: 'Spain', value: 'ES' },
    { country: 'Sweden', value: 'SE' },
    { country: 'Switzerland', value: 'CH' },
    { country: 'United Kingdom', value: 'GB' },
  ];

  get taxCode(): { country: string; value: string }[] {
    return this._taxCode;
  }
}
